import { AddLocationAltRounded, AspectRatioRounded, DirectionsRunRounded, SyncRounded } from '@mui/icons-material';
import { Box, CardMedia, FilledInput, FormControl, Grid, IconButton, InputLabel, TextField, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import useAspectRatio from '../../../../hooks/useAspectRatio';
import { isMobile } from 'react-device-detect';
import { addNewJob, listJobs, syncJobs } from '../../../../store/actions/jobs';
import { CALENDER_PROPS, USER_TYPE } from '../../../../utils/constants';
import { useAuth } from '../../../../hooks/useAuth';
import { useEffect, useState } from 'react';
import { REDUX_ACTIONS } from '../../../../shared/config/constants';
import SyncMobileDevicesModal from '../SyncMobileDevices/SyncMobileDevicesModal';
import Premium from '../../../../assets/images/PRO logo PMS green only.svg';
import styles from './styles';
import { containsAnyKeys } from '../../../../utils/objectHelpers';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

const usersWithSyncAccess = [USER_TYPE.PREMIUM_ADMIN, USER_TYPE.PREMIUM_REALTIME_MPD_ADMIN];

const JobsControls = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [syncCompleted, setSyncCompleted] = useState(false);
  const [selectedStartDateTime, setSelectedStartDateTime] = useState(null);
  const [selectedEndDateTime, setSelectedEnDateTime] = useState(null);
  const [searchTerm, setSearchTerm] = useState(null);
  const handleAspectRatio = useAspectRatio();
  const { preferences } = useSelector((state) => state.currentUser);
  const { user } = useAuth();
  const jobs = useSelector((state) => state.jobs);
  const classes = styles();

  if (isMobile || user.type === USER_TYPE.MPD_CUSTOMER_USER) return null;

  const handleSearchTerm = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleStartTime = (date) => {
    setSelectedStartDateTime(date);
  };
  const handleEndTime = (date) => {
    setSelectedEnDateTime(date);
  };

  const handleSearch = () => {
    const body = {
      searchValue: searchTerm,
      startDate: selectedStartDateTime,
      endDate: selectedEndDateTime
    };
    dispatch({
      type: REDUX_ACTIONS.JOBS_LIST_SEARCH_CONTROL,
      payload: body,
    });
    dispatch(listJobs(body));
  };

  const handleAddToJobs = () => {
    dispatch(addNewJob());
  };

  const handleOpenModal = () => {
    setOpen(true);
    setSyncCompleted(false);
    dispatch({
      type: REDUX_ACTIONS.JOBS_SYNC_IDLE,
      payload: {
        message: '',
      },
    });
  };

  const handleCloseModal = () => {
    setOpen(false);
    dispatch({
      type: REDUX_ACTIONS.JOBS_SYNC_IDLE,
      payload: {
        message: '',
      },
    });
  };

  const handleSyncJobs = () => {
    dispatch(syncJobs(setSyncCompleted));
  };

  useEffect(() => {
    const start = new Date();
    start.setFullYear(start.getFullYear() - 1);
    const end = new Date();
    const body = {
      searchValue: searchTerm,
      startDate: start,
      endDate: end
    };
    setSelectedStartDateTime(start);
    setSelectedEnDateTime(end);
    dispatch({
      type: REDUX_ACTIONS.JOBS_LIST_SEARCH_CONTROL,
      payload: {
        searchValue: searchTerm,
        startDate: start,
        endDate: end
      },
    });
    dispatch(listJobs(body));
  }, []);

  return (
    <Grid alignItems="flex-end" justifyContent="flex-end" sx={{ marginLeft: 'auto' }}>
      <Box className={classes.container}>
        <Box>
          <FormControl
            sx={{ marginRight: '1vh' }}
          >
            <InputLabel
              htmlFor="outlined-adornment-search"
              inputprops={{ classes: { root: classes.searchBar } }}
            >
              Search
            </InputLabel>
            <FilledInput
              className={classes.searchBar}
              id="outlined-adornment-search"
              type="text"
              label="Search"
              value={searchTerm || ''}
              onChange={handleSearchTerm}
            />
          </FormControl>
        </Box>
        <Box className={classes.dateContainer}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateTimePicker
              {...CALENDER_PROPS}
              label="Start Date"
              value={selectedStartDateTime}
              onChange={handleStartTime}
              className={classes.dateTimePicker}
              classes={{
                switchHeader: classes.datePickerHeader,
              }}
              disableFuture
              textField={(params) => <TextField {...params} />}
            />
            <DateTimePicker
              {...CALENDER_PROPS}
              label="End Date"
              value={selectedEndDateTime}
              onChange={handleEndTime}
              className={classes.dateTimePicker}
              disabled={!selectedStartDateTime}
              disableFuture
              minDate={selectedStartDateTime}
              textField={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
        </Box>
        <IconButton
          aria-label="orders"
          edge="end"
          onClick={handleSearch}
        >
          <DirectionsRunRounded />
        </IconButton>
        <IconButton
          edge="end"
          onClick={handleAddToJobs}
          disabled={jobs.loading === true}
          sx={{ marginLeft: 1 }}
        >
          <AddLocationAltRounded />
        </IconButton>
        {(usersWithSyncAccess.includes(user.type) || (user.type === USER_TYPE.PREMIUM_SELECT_ADMIN &&
              containsAnyKeys(usersWithSyncAccess, user?.accessLevels || []))) &&
          <IconButton
            edge="end"
            onClick={() => {
              handleOpenModal();
            }}
            sx={{ marginLeft: 1 }}
            disabled={jobs.loading === true}
            >
            <SyncRounded />
          </IconButton>
        }
        <IconButton
          edge="end"
          onClick={() => {
            handleAspectRatio(!preferences.aspectChanged);
          }}
          sx={{ marginLeft: 1 }}
        >
          <AspectRatioRounded />
        </IconButton>
      </Box>
    <SyncMobileDevicesModal
      open={open}
      onClose={handleCloseModal}
      handleClose={handleCloseModal}
      cta2Label={'Sync'}
      cta2Disabled={jobs.loadingJobSync}
      cta2Action={handleSyncJobs}
      showCta2={!syncCompleted}
      showDateTimeRange={false}
    >
      <CardMedia
        component="img"
        image={Premium}
        className={classes.logo}
      />

      <Typography variant="h3" gutterBottom component="div" className={classes.title}>
        Sync Mobile Devices?
      </Typography>

      { jobs.syncResponseMessage !== ''
        ? <Typography variant="h5" marginBottom='50px' gutterBottom component="div" className={classes.statusMessage}>
          {jobs.syncResponseMessage}
        </Typography>
        : <div style={{
          height: 40,
        }}></div>
      }
    </SyncMobileDevicesModal>
  </Grid>
  );
};

export default JobsControls;
